import ReportedMediaSummary from "./ReportedMediaSummary";
export default ReportedMediaSummary;
